import { createFileRoute } from "@tanstack/react-router";
import AdminSBOPResponses from "@/pages/AdminSBOPResponses";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/sbop-responses/")({
  component: () => (
    <RoleGate allow={['staff']} area="SBOP Responses"><AdminSBOPResponses /></RoleGate>
  ),
});
